import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemStockFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemStockFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-stocks'
*/
const RemoveItemStockFromSupplierOrderController = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveItemStockFromSupplierOrderController.url(args, options),
    method: 'delete',
})

RemoveItemStockFromSupplierOrderController.definition = {
    methods: ["delete"],
    url: '/api/supplier-order/{supplier_order}/item-stocks',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemStockFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemStockFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-stocks'
*/
RemoveItemStockFromSupplierOrderController.url = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { supplier_order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { supplier_order: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            supplier_order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        supplier_order: typeof args.supplier_order === 'object'
        ? args.supplier_order.id
        : args.supplier_order,
    }

    return RemoveItemStockFromSupplierOrderController.definition.url
            .replace('{supplier_order}', parsedArgs.supplier_order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SupplierOrder\RemoveItemStockFromSupplierOrderController::__invoke
* @see app/Http/Controllers/SupplierOrder/RemoveItemStockFromSupplierOrderController.php
* @route '/api/supplier-order/{supplier_order}/item-stocks'
*/
RemoveItemStockFromSupplierOrderController.delete = (args: { supplier_order: string | number | { id: string | number } } | [supplier_order: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: RemoveItemStockFromSupplierOrderController.url(args, options),
    method: 'delete',
})

export default RemoveItemStockFromSupplierOrderController